










import Vue from 'vue'
import ShippingAddressList from '@/components/molecules/ShippingAddress/ShippingAddressList.vue'
import XContainer from '@/components/atoms/Container/XContainer.vue'

export default Vue.extend({
  components: { ShippingAddressList, XContainer },
  methods: {
    onAddAddress() {
      this.$router.push({ name: 'ShippingAddressCreate' })
    },
  },
})
